const uploadRecipientsResources = {
    uploadResultsLabel: '*Here is the list of members that have not been uploaded. Please fix their information in file and try again',
    uploadResultsTitle: 'Recipients Upload Results',
    labelRowNumber: 'Row Number',
    labelFullName: 'Employee Name',
    labelEmail: 'Email',
    labelReason: 'Failure Reason',
};

export default uploadRecipientsResources;